import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { PqrService } from '../../../service/pqr/pqr.service';
import { Pqr } from '../../../class/pqr';

@Component({
  selector: 'app-pqr',
  templateUrl: './pqr.component.html',
  styleUrls: ['./pqr.component.scss']
})
export class PqrComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoPqr: Pqr;
    public pqr: Pqr;
    public msgs: Message[] = [];
    public options: any;
    public latitude: number;
    public longitude: number;
    public zoom: number;
    public overlays: any[];

    constructor(
        public pqrService: PqrService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelPqr () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqrs/pqr/pqr.component.ts